import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_2wz5bc8qwr: FaireCollectionEntity = {
  token: "pbc_2wz5bc8qwr",
  type: "collection",
  name: "Wordy Sweater Knits Baby Collection",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a8caaa7865da609c78cbddb14857e47c272d535fb497c8e64fcdfba532785a88.jpeg",
  itemCount: 23,
  description:
    "Eco-chic baby knits made from 100% certified ORGANIC COTTON.\nSuper soft, sustainable, non-toxic & eco-friendly.\nElegant styles with meticulous detailing.\nMade from small farmer-sourced organic cotton, supporting & improving rural livelihoods in India.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:21.576Z",
    importedBy: "entity-db-import-collections",
  },
};
